<template>
  <v-container fluid class="admin-page">
    <v-row>
      <v-col cols="6">
        <h2>Faq Category</h2>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="4" offset="7">
            <router-link to="/dashboard/add/faq_category">
              <v-btn class="text--futura text--white text-capitalize" dark block>
                Add Faq Category
              </v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12">
        <Alert />
        <v-data-table :loading="tableLoading" :headers="headers" :items="faqCategories" :items-per-page="5" class="elevation-1">
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small text @click="showDeleteDialog(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DeleteDialog :message="`Remove Faq Category ${faqCategory.name} ?`" :item="faqCategory" :showDelete="showDelete" @deleteItem="deleteFaqCategory"
      @closeDialog="closeDialog" />
  </v-container>
</template>

<script>
import Alert from "../components/Alert.vue";
import DeleteDialog from "../components/DeleteDialog.vue";
import server from "../api";

export default {
  name: "FaqCategory",
  components: {
    Alert,
    DeleteDialog,
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Action", value: "actions" },
      ],
      showDelete: false,
      faqCategory: {}
    };
  },
  methods: {
    showDeleteDialog(faqCategory) {
      this.faqCategory = faqCategory;
      this.showDelete = true;
    },
    closeDialog() {
      this.showDelete = false;
    },
    deleteFaqCategory(id) {
      server
        .delete(`/faq_categories/${id}`, {
          headers: {
            token: localStorage.token,
          },
        })
        .then((result) => {
          this.showDelete = false;
          this.$store.dispatch("getFaqCategory");
          this.$store.commit(
            "SET_SUCCESS",
            `Berhasil Menghapus Faq Category ${result.data.name}`
          );
        })
        .catch((err) => {
          this.$store.commit("SET_ERROR", err.data.response.errors[0].message);
        });
    },
    editItem(item) {
      this.faqCategory = item;
      this.$router.push({
        path: `/dashboard/edit/faq_category/${this.faqCategory.id}`,
      });
    },
  },
  computed: {
    faqCategories() {
      return this.$store.state.faqCategory;
    },
    tableLoading() {
      return this.$store.state.tableLoading;
    },
  },
  created() {
    this.$store.dispatch("getFaqCategory");
  },
};
</script>